import { LinearProgress } from '@mui/material';

import { useLoadingTileStore } from '../stores/useLoadingTilesStore';

export function SeismicLayerLoadingProgress(){
    const percentage = useLoadingTileStore(state => state.percentage);
    return  <LinearProgress variant='determinate' value={percentage} />;
}